import { ExpirationsContainer } from '../../components/expirations/ExpirationsContainer'

export const Expirations = () => {
  return (
    <ExpirationsContainer/>
  )
}
